import React from 'react'

import { FormattedMessage } from 'sb-react-intl'
import commonMessages from 'components/layout/Footer/FooterView/messages'

import FooterColumnTitle from '../FooterColumnTitle/FooterColumnTitle'
import FooterSocials from '../../FooterSocials/FooterSocials'


const FooterFollowUs = ({ collectEmailFormNode }) => (
  <div>
    <FooterColumnTitle>
      <FormattedMessage {...commonMessages.followUs} />
    </FooterColumnTitle>
    <FooterSocials />
    {collectEmailFormNode}
  </div>
)

export default FooterFollowUs
